module.exports = __webpack_public_path__ + "static/media/symbolic-calculation-dark.b56ef8e1.png";